module.exports = __webpack_public_path__ + "img/chevron-up-double.89240ad0.svg";